module.exports = __webpack_public_path__ + "media/images/icon-svg/close-5bd938527ded047f02a565133bd44277.svg";